// autopilot-secrets-template-command.ts — 06k security L-03:
// `avatar autopilot secrets-template --mission <id> --keys <K1,K2> [--delegated] [--json]`.
// Tạo khung test.env (0700/0600, O_EXCL, không ghi đè, không đọc giá trị). Mission
// phải tồn tại trong workspace (resolveMission) — id không thành path tuỳ ý.
// `--delegated` được nhận (chat-drive luôn gửi) và không cần `--reason`: lệnh không
// ghi quyết định nào.
import type { Command } from "commander";
import { resolveMission } from "../lib/autopilot/mission-resolver.js";
import {
  parseTestEnvTemplateKeys,
  writeTestEnvTemplate,
} from "../lib/autopilot/mission-secrets-test-env-template-writer.js";
import {
  writeMachineReadableError,
  writeMachineReadableJson,
} from "../lib/machine-readable-json-output-contract.js";
import { log } from "../lib/terminal-logger.js";

const COMMAND = "autopilot secrets-template";

export function registerAutopilotSecretsTemplateCommand(
  autopilot: Command,
  deps: { resolveWorkspaceRoot: (repoFlag: string | undefined) => Promise<string> },
): void {
  autopilot
    .command("secrets-template")
    .description("Tạo khung ~/.avatar/secrets/<mission>/test.env (0600, không ghi đè)")
    .requiredOption("--mission <id>", "Mission ID")
    .requiredOption("--keys <list>", "Tên biến, phân tách bằng dấu phẩy (A-Z, 0-9, _)")
    .option("--delegated", "Gọi từ phiên chat Claude Code (06k) — không cần --reason")
    .option("--repo <path>", "Repo path để resolve mission")
    .option("--json", "Output JSON")
    .action(async (opts: { mission: string; keys: string; repo?: string; json?: boolean }) => {
      try {
        const keys = parseTestEnvTemplateKeys(opts.keys);
        const workspaceRoot = await deps.resolveWorkspaceRoot(opts.repo);
        const { missionId } = await resolveMission({
          workspaceRoot,
          explicitMissionId: opts.mission,
        });
        const result = await writeTestEnvTemplate(missionId, keys);
        if (opts.json) writeMachineReadableJson({ command: COMMAND, ...result });
        else if (result.created)
          log.success(`Đã tạo ${result.path} — điền giá trị cho: ${keys.join(", ")}`);
        else log.info(`${result.path} đã có — không ghi đè, không đọc. Tự thêm dòng còn thiếu.`);
      } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        if (opts.json) writeMachineReadableError(COMMAND, message);
        else log.error(message);
        process.exitCode = 1;
      }
    });
}
